<template>
    <div class="homelogin-page">
        <top-bar
            activeTab="home"
            :isLogin="isLogin"
            :modalController="modalController"
            ref="top-bar"
            @switchLang="switchLang($event)"
            @logout="logout()"
        ></top-bar>
        <div class="layout-login">
            <div class="container login">
                <div class="card" v-if="!isLogin">
                    <div class="card-body">
                        <div class="logo-box">
                            <img class="img-logo" src="" />
                        </div>
                        <div class="form-group">
                            <InputNumber
                                v-model="modelLogin.username"
                                inputId="input-address-id-card"
                                key="input-address-id-card"
                                :inputLbl="register.nationalid"
                                :inputMinLength="13"
                                :inputMaxLength="13"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="errorInfo[0]"
                            ></InputNumber>
                        </div>
                        <div class="form-group">
                            <InputContactNumber
                                v-model="modelLogin.password"
                                inputId="register-contact-number"
                                :inputLbl="register.contactNumber"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="errorInfo[1]"
                                delimeter="-"
                            ></InputContactNumber>
                        </div>
                        <div
                            class="form-group text-center"
                            style="margin: 30px 0;font-size: 17px;"
                        >
                            <button
                                type="button"
                                class="btn btn-primary"
                                style="width: 100%;"
                                @click="clickSubmit()"
                            >
                                {{ lbl.main.login }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card" v-else-if="isLogin && profile">
                    <div class="card-body">
                        <h4>Hello {{ profile.strDisplayName }}</h4>
                        <div>{{ profile.strEmail }}</div>
                    </div>
                </div>
            </div>
        </div>

        <modal-master :controller="modalController"></modal-master>
    </div>
</template>

<script>
// @ is an alias to /src
// import Vue from "vue";
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
// import Util from "@/helper/Utility.js";
//component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import InputContactNumber from "@/components/Input/ContactNumber.vue";
import InputNumber from "@/components/Input/Number.vue";
import FormHelper from "@/helper/FormHelper.js";
import CacheHelper from "@/helper/CacheHelper.js";
import ConfigManager from "@/config/ConfigManager.js";

//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import AccountMixin from "@/mixin/AccountMixin.js";
import Mixin from "@/mixin/Mixin";

//service
import { TrackingService } from "@/helper/TrackingHelper.js";
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import LineFunction from "@/helper/facade/LineFunction.js";

export default {
    name: "home",
    components: {
        TopBar,
        InputContactNumber,
        InputNumber
    },
    mixins: [Mixin, AccountMixin, LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            isLogin: false,
            isFirstSave: true,

            modelLogin: {
                username: "",
                password: ""
            },

            channel: "Login",

            // all new modal
            modalController: null,
            alertModal: null,
            loadingModal: null,
            confirmModal: null,

            tracking: new TrackingService(this),

            point: 0,
            textKey: "test",
            textKey1: "",
            textKey2: "",
            register: {
                contactNumber: {
                    name: "กรอกหมายเบอร์โทรศัพท์มือถือ",
                    placeholder: "กรุณาเบอร์โทรศัพท์มือถือ",
                    required: "กรุณากรอกเบอร์โทรศัพท์มือถือ",
                    too_short: "",
                    invalid: "เบอร์โทรศัพท์มือถือไม่ถูกต้อง"
                },
                nationalid: {
                    name: "เลขประจำตัวประชาชน",
                    placeholder: "กรุณากรอกเลขบัตรประชาชน 13 หลัก",
                    required: "กรุณากรอกเลขประจำตัวประชาชน",
                    too_short: "กรุณากรอกเลขบัตรประชาชน 13 หลัก",
                    invalid: "เลขประจำตัวประชาชนไม่ถูกต้อง"
                }
            }
        };
    },
    created: function() {
        // Account.loginStatus().then(status => {
        //     this.isLogin = status;
        //     if (status) {
        //         // do something
        //     }
        // });
        this.errorInfo = FormHelper.genErrorInfo(2);
        var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
        var toontest = cacheHelper.getCache("test");
        if (toontest) {
            this.modelLogin = toontest;
            cacheHelper.removeCache("test");
        }
        if (this.$root.foo) {
            this.openOtpModal();
        }
    },
    mounted: function() {
        this.initLiff();
    },
    methods: {
        initLiff: function() {
            Vue.$cookies.remove("checkConsent");
            var lineFunction = new LineFunction();
            this.liffId = Vue.bzbsConfig.liffId;

            lineFunction
                .init(this.liffId)
                .then(() => {
                    this.idToken = lineFunction.getIdToken();
                    console.log(this.idToken);
                    Account.setCacheLineIdToken(this.idToken);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        login: function() {
            Account.apiBzbsLogin(
                this.modelLogin.username,
                this.modelLogin.password
            )
                .then(objResult => {
                    this.isLogin = true;
                    console.log(objResult);
                    window.location.reload();
                })
                .catch(error => {
                    console.log(error);
                    this.errorApi(error);
                });
        },
        clickSubmit: function() {
            this.isFirstSave = false;
            if (this.validateForm()) {
                this.contactNumber = this.modelLogin.password;
                this.idCard = this.modelLogin.username;
                var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
                cacheHelper.setCache("test", this.modelLogin);
                this.goto("consent");
            }
        },
        openOtpModal: function() {
            this.handleLoading(true);
            setTimeout(() => {
                this.contactNumber = this.modelLogin.password;
                this.idCard = this.modelLogin.username;
                this.otpModal.startOtp(
                    this.contactNumber,
                    this.channel,
                    this.idToken,
                    this.idCard
                );

                this.otpModal.onSubmitOtp(data => {
                    this.registertest(data);
                });

                this.otpModal.onHidden(data => {
                    console.log(data);
                });
            }, 1000);

            // this.tracking.event(this.trackingCat, "click_register");
        },
        registertest: async function(otp) {
            console.log(otp);
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            cacheHelper.setCache("isNewRegister", true);
            setTimeout(() => {
                window.location.replace("/linelogin");
            }, 1000);
        },
        validateForm: function() {
            return FormHelper.validate(this.errorInfo);
        },
        deviceLogin: function() {
            this.loadingModal.show();
            var uuid = "DEV_307c5e91-2cf2-9065-7465-f5130e43330f";
            Account.apiDeviceLoginWithUUID(uuid)
                .then(() => {
                    this.loadingModal.hide();
                    window.location.reload();
                })
                .catch(err => {
                    this.loadingModal.hide();
                    this.errorResponse(err);
                });
        },

        testObserveApi: function() {
            var token = Account.getToken();

            BzbsProfile.getPoint(token).subscribe(
                profilePoint => {
                    console.log(profilePoint);
                },
                err => {
                    console.log(err);
                    if (err.id == 401) {
                        console.log("Go login");
                    } else {
                        this.errorResponse(err); // call mixin function
                    }
                }
            );
        },
        goto(page) {
            this.$router.push("/" + page);
        },
        clickShowAlert: function() {
            setTimeout(() => {
                this.alertModal
                    .clearModal()
                    .setTitle("ยืนยันตัวตนผ่าน OTP")
                    .setMsg("modal message")
                    .setBtnOk("ยืนยัน")
                    .setTag("alert-1")
                    .show();
                this.alertModal.onClickOk(data => {
                    console.log(data);
                    console.log("alert ok");
                });
                this.alertModal.onHidden(data => {
                    console.log(data);
                    console.log("alert hidden");
                });
            }, 500);
        },
        clickShowAlertOtp: function() {
            setTimeout(() => {
                this.otpModal.show();
                this.otpModal.onClickOk(data => {
                    console.log(data);
                    console.log("alert ok");
                });
                this.otpModal.onHidden(data => {
                    console.log(data);
                    console.log("alert hidden");
                });
            }, 500);
        },
        onKey1: function() {
            this.textKey = this.textKey1;
        },
        onKey2: function() {
            this.textKey = this.textKey2;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/homelogin.scss";
</style>
